export default "__VITE_ASSET__DFNzpQIp__"